export class Language{
    public LanguageId:number;

    public Name:string;

    public Description:string;

    public LanguageCode:string;
    
    public LanguageIconUrl:string;

    public SortOrder:string;

    public IsDeleted:boolean;

    public static readonly ENGLISH:number = 1;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/language.ts